import { useDispatch } from 'react-redux';
import { Col, Alert, Spinner } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { createSelector } from 'reselect';
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { getResidueList } from '../../../slices/thunks';
import { Link } from 'react-router-dom';
import AddEditResidueModal from './Add_Edit/AddEditResidueModal';
import DeleteResidue from './Delete/DeleteResidue';
import { ODataGrid } from '../../../Components/OElements/ODataGrid';

const ResiduesList = () => {
	const dispatch = useDispatch();
	const history = useNavigate();

	const selectorResidues = createSelector(
		state => state.Residues,
		residue => ({
			residueList: residue.residueList,
			isLoadingList: residue.isLoadingList,
			isResidueSuccess: residue.isResidueSuccess,
			error: residue.error,
			isAdding: residue.isAdding,
			isAdded: residue.isAdded,
			isAddError: residue.isAddError,
			isUpdating: residue.isUpdating,
			isUpdated: residue.isUpdated,
			isUpdateError: residue.isUpdateError,
			isDeleting: residue.isDeleting,
			isDeleted: residue.isDeleted,
			isDeleteError: residue.isDeleteError,
		})
	);

	const { residueList, isLoadingList } = useSelector(selectorResidues);

	useEffect(() => {
		dispatch(getResidueList());
	}, []);

	const [dataResidue, setDataResidue] = useState({});
	const [isEdit, setIsEdit] = useState(false);

	// Delete Residue
	const [modal, setModal] = useState(false);
	const [modalDelete, setModalDelete] = useState(false);
	//Tab
	const [activeTab, setActiveTab] = useState('1');
	const toggleTab = tab => {
		if (activeTab !== tab) {
			setActiveTab(tab);
		}
	};

	function handleToggleModal() {
		setModal(!modal);
		toggleTab('1');
		// validation.resetForm();
	}

	function handleToggleModalDelete() {
		setModalDelete(!modalDelete);
	}

	// Delete Data
	const handleClickDelete = residue => {
		setDataResidue(residue);
		setModalDelete(true);
	};

	// Update Data
	const handleClickEdit = residue => {
		setDataResidue(residue);
		handleToggleModal();
	};

	const columns = useMemo(
		() => [
			{
				header: 'Acciones', enableSorting: false, enableColumnFilter: false, enableGlobalFilter: false, enableColumnActions: false,
				accessorKey: 'residue',
				columnDefType: 'display',
				Cell: cellProps => {
					return (
						<React.Fragment>
							<div className='d-flex'>
								<div className='flex-shrink-0'>
									<ul className='list-inline mb-0'>
										<li className='list-inline-item'>
											<Link
												to='#'
												onClick={() => {
													const residueData =
														cellProps.row.original;
													setIsEdit(true);
													handleClickEdit(residueData);
												}}
											>
												<i className='ri-pencil-fill align-bottom me-2 text-muted'></i>
											</Link>
										</li>
										<li className='list-inline-item'>
											<Link
												to='#'
												className='remove-item-btn'
												onClick={() => {
													const residueData =
														cellProps.row.original;
													handleClickDelete(residueData);
												}}
											>
												<i className='ri-delete-bin-line align-bottom me-2 text-muted'></i>
											</Link>
										</li>
									</ul>
								</div>
							</div>
						</React.Fragment>
					);
				},
			},
			{
				header: 'Nombre',
				accessorKey: 'name',
				dataType: 'string',
				size: 'auto',
			},
			{
				header: 'Categoría de Residuo',
				accessorKey: 'residue_category.name',
				dataType: 'string',
				filterVariant: 'select',
				size: 'auto',
			},
			{ header: 'LER', accessorKey: 'LER',  size: 'auto' },
			{
				header: '¿Es orgánico?',
				accessorKey: 'organic',
				dataType: 'boolean',
				Cell: ({ row }) => {
					return (
						<input
							className='form-check-input'
							role='switch'
							type='checkbox'
							id='disabled'
							name='disabled'
							disabled
							checked={row.original.organic}
						/>
					);
				},
			},
			{
				header: 'Volumen',
				accessorKey: 'volumen',
			},
		],
		[handleClickEdit]
	);

	return (
		<React.Fragment>
			<div className='row'>
				<Col lg={12}>
					<div className='card'>
						{/* <div className='card-header border-0'>
							<div className='d-flex align-items-center'>
								<h5 className='card-title mb-0 flex-grow-1'>
									Lista de Residuos
								</h5>
								<div className='flex-shrink-0'>
									<div className='d-flex flex-wrap gap-2'>
										<button
											className='btn btn-label btn-primary'
											onClick={() => {
												setIsEdit(false);
												setDataResidue({});
												handleToggleModal();
											}}
										>
											<i className={`${Icons.plus} label-icon`}></i>{' '}
											Crear Residuo
										</button>
									</div>
								</div>
							</div>
						</div> */}
						<div className='card-body pt-3'>
							<ODataGrid
								data={residueList || []}
								columns={columns}
								isLoadingData={isLoadingList}
								nameFile={'residuos'}
								customToolbarActions={[
									{
										label: 'Crear',
										icon: Icons.plus,
										onClick: () => {
											setIsEdit(false);
											setDataResidue({});
											handleToggleModal();
										},
										title: 'Crear Residuo',
									}
								]}
							/>
						</div>
					</div>
				</Col>
			</div>

			<AddEditResidueModal
				dataResidue={dataResidue}
				isEdit={isEdit}
				isOpen={modal}
				handleToggleModal={handleToggleModal}
				activeTab={activeTab}
				toggleTab={toggleTab}
			/>
			<DeleteResidue
				dataResidue={dataResidue}
				isOpen={modalDelete}
				handlerToggleModal={handleToggleModalDelete}
			/>
		</React.Fragment>
	);
};

export default ResiduesList;
